
const { createGlobalStyle } = require('styled-components');

module.exports = createGlobalStyle`
html{
  font-family:sans-serif;
  font-size:${props => props.theme.fontSizeBase};
  line-height:1.15;
  -ms-text-size-adjust:100%;
  -webkit-text-size-adjust:100%;

  -webkit-box-sizing:border-box;

          box-sizing:border-box;
  height:100%;
  -ms-overflow-style:scrollbar;
  -webkit-tap-highlight-color:rgb(0 0 0 / 0%);
}
*,
*::before,
*::after{
  -webkit-box-sizing:inherit;
          box-sizing:inherit;
}
@-ms-viewport{
  width:device-width;
}
article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section{
  display:block;
}
body{
  font-family:${props => props.theme.fontFamilyBase};
  font-weight:${props => props.theme.fontWeightBase};
  line-height:${props => props.theme.lineHeightBase};

  height:100%;

  margin:0;

  color:${props => props.theme.palette.content};
  background-color:${props => props.theme.palette.backgroundPrimary};
}
[tabindex="-1"]:focus{
  outline:none !important;
}
hr{
  overflow:visible;

  -webkit-box-sizing:content-box;

          box-sizing:content-box;
  height:0;
}
h1,
h2,
h3,
h4,
h5,
h6{
  margin-top:0;
  margin-bottom:0.5rem;
}
p{
  margin-top:0;
  margin-bottom:1.5rem;
}
abbr[title],
abbr[data-original-title]{
  cursor:help;
  text-decoration:underline;
  -webkit-text-decoration:underline dotted;
          text-decoration:underline dotted;

  border-bottom:0;
}
address{
  font-style:normal;
  line-height:inherit;

  margin-bottom:1rem;
}
ol,
ul,
dl{
  margin-top:0;
  margin-bottom:1rem;
}
ol ol,
ul ul,
ol ul,
ul ol{
  margin-bottom:0;
}
dt{
  font-weight:${props => props.theme.dtFontWeight};
}
dd{
  margin-bottom:0.5rem;
  margin-left:0;
}
blockquote{
  margin:0 0 1rem;
}
dfn{
  font-style:italic;
}
b,
strong{
  font-weight:bolder;
}
small{
  font-size:80%;
}
sub,
sup{
  font-size:75%;
  line-height:0;

  position:relative;

  vertical-align:baseline;
}
sub{
  bottom:-0.25em;
}
sup{
  top:-0.5em;
}
a{
  cursor:pointer;
  -webkit-text-decoration:${props => props.theme.linkDecoration};
          text-decoration:${props => props.theme.linkDecoration};

  color:${props => props.theme.palette.actionableSecondary};
  background-color:transparent;
  -webkit-text-decoration-skip:objects;
}
a:hover{
    -webkit-text-decoration:${props => props.theme.linkHoverDecoration};
            text-decoration:${props => props.theme.linkHoverDecoration};

    color:${props => props.theme.palette.actionableSecondary};
  }
pre,
code,
kbd,
samp{
  font-family:monospace, monospace;
  font-size:1em;
}
pre{
  overflow:auto;
  margin-top:0;
  margin-bottom:1rem;
}
figure{
  margin:0 0 1rem;
}
img{
  vertical-align:middle;

  border-style:none;
}
svg:not(:root){
  overflow:hidden;
}
a,
area,
button,
[role="button"],
input,
label,
select,
summary,
textarea{
  -ms-touch-action:manipulation;
      touch-action:manipulation;
}
table{
  border-collapse:collapse;
}
caption{
  padding-top:${props => props.theme.tableCellPadding};
  padding-bottom:${props => props.theme.tableCellPadding};

  caption-side:bottom;

  text-align:left;

  color:${props => props.theme.palette.semanticInfo};
}
th{
  text-align:left;
}
label{
  display:inline-block;

  margin-bottom:0.5rem;
}
input,
button,
select,
optgroup,
textarea{
  font-family:inherit;
  font-size:inherit;
  line-height:inherit;

  margin:0;
}
button,
input{
  overflow:visible;
}
button,
select{
  text-transform:none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"]{
  -webkit-appearance:button;
}
input[type="radio"],
input[type="checkbox"]{
  -webkit-box-sizing:border-box;
          box-sizing:border-box;
  padding:0;
}
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"]{
  -webkit-appearance:listbox;
}
textarea{
  overflow:auto;
  resize:vertical;
}
fieldset{
  min-width:0;
  margin:0;
  padding:0;

  border:0;
}
legend{
  font-size:1.5rem;
  line-height:inherit;

  display:block;

  width:100%;
  max-width:100%;
  margin-bottom:0.5rem;
  padding:0;

  white-space:normal;

  color:inherit;
}
progress{
  vertical-align:baseline;
}
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button{
  height:auto;
}
[type="search"]{
  outline-offset:-2px;
  -webkit-appearance:none;
}
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration{
  -webkit-appearance:none;
}
::-webkit-file-upload-button{
  font:inherit;
  -webkit-appearance:button;
}
output{
  display:inline-block;
}
summary{
  display:list-item;
}
template{
  display:none;
}
[hidden]{
  display:none !important;
}
.container-fluid,
.container{
  margin-right:auto;
  margin-left:auto;
}
.container-fluid{
  padding-right:2rem;
  padding-left:2rem;
}
.row{
  -webkit-box-sizing:border-box;
          box-sizing:border-box;
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-flex:0;
  -ms-flex:0 1 auto;
  flex:0 1 auto;
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -ms-flex-direction:row;
  flex-direction:row;
  -ms-flex-wrap:wrap;
  flex-wrap:wrap;
  margin-right:-0.5rem;
  margin-left:-0.5rem;
}
.row.reverse{
  -webkit-box-orient:horizontal;
  -webkit-box-direction:reverse;
  -ms-flex-direction:row-reverse;
  flex-direction:row-reverse;
}
.col.reverse{
  -webkit-box-orient:vertical;
  -webkit-box-direction:reverse;
  -ms-flex-direction:column-reverse;
  flex-direction:column-reverse;
}
.col-xs,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-offset-0,
.col-xs-offset-1,
.col-xs-offset-2,
.col-xs-offset-3,
.col-xs-offset-4,
.col-xs-offset-5,
.col-xs-offset-6,
.col-xs-offset-7,
.col-xs-offset-8,
.col-xs-offset-9,
.col-xs-offset-10,
.col-xs-offset-11,
.col-xs-offset-12{
  -webkit-box-sizing:border-box;
          box-sizing:border-box;
  -webkit-box-flex:0;
  -ms-flex:0 0 auto;
  flex:0 0 auto;
  padding-right:0.5rem;
  padding-left:0.5rem;
}
.col-xs{
  -webkit-box-flex:1;
  -ms-flex-positive:1;
  flex-grow:1;
  -ms-flex-preferred-size:0;
  flex-basis:0;
  max-width:100%;
}
.col-xs-1{
  -ms-flex-preferred-size:8.33333333%;
  flex-basis:8.33333333%;
  max-width:8.33333333%;
}
.col-xs-2{
  -ms-flex-preferred-size:16.66666667%;
  flex-basis:16.66666667%;
  max-width:16.66666667%;
}
.col-xs-3{
  -ms-flex-preferred-size:25%;
  flex-basis:25%;
  max-width:25%;
}
.col-xs-4{
  -ms-flex-preferred-size:33.33333333%;
  flex-basis:33.33333333%;
  max-width:33.33333333%;
}
.col-xs-5{
  -ms-flex-preferred-size:41.66666667%;
  flex-basis:41.66666667%;
  max-width:41.66666667%;
}
.col-xs-6{
  -ms-flex-preferred-size:50%;
  flex-basis:50%;
  max-width:50%;
}
.col-xs-7{
  -ms-flex-preferred-size:58.33333333%;
  flex-basis:58.33333333%;
  max-width:58.33333333%;
}
.col-xs-8{
  -ms-flex-preferred-size:66.66666667%;
  flex-basis:66.66666667%;
  max-width:66.66666667%;
}
.col-xs-9{
  -ms-flex-preferred-size:75%;
  flex-basis:75%;
  max-width:75%;
}
.col-xs-10{
  -ms-flex-preferred-size:83.33333333%;
  flex-basis:83.33333333%;
  max-width:83.33333333%;
}
.col-xs-11{
  -ms-flex-preferred-size:91.66666667%;
  flex-basis:91.66666667%;
  max-width:91.66666667%;
}
.col-xs-12{
  -ms-flex-preferred-size:100%;
  flex-basis:100%;
  max-width:100%;
}
.col-xs-offset-0{
  margin-left:0;
}
.col-xs-offset-1{
  margin-left:8.33333333%;
}
.col-xs-offset-2{
  margin-left:16.66666667%;
}
.col-xs-offset-3{
  margin-left:25%;
}
.col-xs-offset-4{
  margin-left:33.33333333%;
}
.col-xs-offset-5{
  margin-left:41.66666667%;
}
.col-xs-offset-6{
  margin-left:50%;
}
.col-xs-offset-7{
  margin-left:58.33333333%;
}
.col-xs-offset-8{
  margin-left:66.66666667%;
}
.col-xs-offset-9{
  margin-left:75%;
}
.col-xs-offset-10{
  margin-left:83.33333333%;
}
.col-xs-offset-11{
  margin-left:91.66666667%;
}
.start-xs{
  -webkit-box-pack:start;
  -ms-flex-pack:start;
  justify-content:flex-start;
  text-align:start;
}
.center-xs{
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center;
  text-align:center;
}
.end-xs{
  -webkit-box-pack:end;
  -ms-flex-pack:end;
  justify-content:flex-end;
  text-align:end;
}
.top-xs{
  -webkit-box-align:start;
  -ms-flex-align:start;
  align-items:flex-start;
}
.middle-xs{
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
}
.bottom-xs{
  -webkit-box-align:end;
  -ms-flex-align:end;
  align-items:flex-end;
}
.around-xs{
  -ms-flex-pack:distribute;
  justify-content:space-around;
}
.between-xs{
  -webkit-box-pack:justify;
  -ms-flex-pack:justify;
  justify-content:space-between;
}
.first-xs{
  -webkit-box-ordinal-group:0;
  -ms-flex-order:-1;
  order:-1;
}
.last-xs{
  -webkit-box-ordinal-group:2;
  -ms-flex-order:1;
  order:1;
}
@media only screen and (min-width: 48em){
  .container{
    width:49rem;
  }

  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-offset-0,
  .col-sm-offset-1,
  .col-sm-offset-2,
  .col-sm-offset-3,
  .col-sm-offset-4,
  .col-sm-offset-5,
  .col-sm-offset-6,
  .col-sm-offset-7,
  .col-sm-offset-8,
  .col-sm-offset-9,
  .col-sm-offset-10,
  .col-sm-offset-11,
  .col-sm-offset-12{
    -webkit-box-sizing:border-box;
            box-sizing:border-box;
    -webkit-box-flex:0;
    -ms-flex:0 0 auto;
    flex:0 0 auto;
    padding-right:0.5rem;
    padding-left:0.5rem;
  }

  .col-sm{
    -webkit-box-flex:1;
    -ms-flex-positive:1;
    flex-grow:1;
    -ms-flex-preferred-size:0;
    flex-basis:0;
    max-width:100%;
  }

  .col-sm-1{
    -ms-flex-preferred-size:8.33333333%;
    flex-basis:8.33333333%;
    max-width:8.33333333%;
  }

  .col-sm-2{
    -ms-flex-preferred-size:16.66666667%;
    flex-basis:16.66666667%;
    max-width:16.66666667%;
  }

  .col-sm-3{
    -ms-flex-preferred-size:25%;
    flex-basis:25%;
    max-width:25%;
  }

  .col-sm-4{
    -ms-flex-preferred-size:33.33333333%;
    flex-basis:33.33333333%;
    max-width:33.33333333%;
  }

  .col-sm-5{
    -ms-flex-preferred-size:41.66666667%;
    flex-basis:41.66666667%;
    max-width:41.66666667%;
  }

  .col-sm-6{
    -ms-flex-preferred-size:50%;
    flex-basis:50%;
    max-width:50%;
  }

  .col-sm-7{
    -ms-flex-preferred-size:58.33333333%;
    flex-basis:58.33333333%;
    max-width:58.33333333%;
  }

  .col-sm-8{
    -ms-flex-preferred-size:66.66666667%;
    flex-basis:66.66666667%;
    max-width:66.66666667%;
  }

  .col-sm-9{
    -ms-flex-preferred-size:75%;
    flex-basis:75%;
    max-width:75%;
  }

  .col-sm-10{
    -ms-flex-preferred-size:83.33333333%;
    flex-basis:83.33333333%;
    max-width:83.33333333%;
  }

  .col-sm-11{
    -ms-flex-preferred-size:91.66666667%;
    flex-basis:91.66666667%;
    max-width:91.66666667%;
  }

  .col-sm-12{
    -ms-flex-preferred-size:100%;
    flex-basis:100%;
    max-width:100%;
  }

  .col-sm-offset-0{
    margin-left:0;
  }

  .col-sm-offset-1{
    margin-left:8.33333333%;
  }

  .col-sm-offset-2{
    margin-left:16.66666667%;
  }

  .col-sm-offset-3{
    margin-left:25%;
  }

  .col-sm-offset-4{
    margin-left:33.33333333%;
  }

  .col-sm-offset-5{
    margin-left:41.66666667%;
  }

  .col-sm-offset-6{
    margin-left:50%;
  }

  .col-sm-offset-7{
    margin-left:58.33333333%;
  }

  .col-sm-offset-8{
    margin-left:66.66666667%;
  }

  .col-sm-offset-9{
    margin-left:75%;
  }

  .col-sm-offset-10{
    margin-left:83.33333333%;
  }

  .col-sm-offset-11{
    margin-left:91.66666667%;
  }

  .start-sm{
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    text-align:start;
  }

  .center-sm{
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    text-align:center;
  }

  .end-sm{
    -webkit-box-pack:end;
    -ms-flex-pack:end;
    justify-content:flex-end;
    text-align:end;
  }

  .top-sm{
    -webkit-box-align:start;
    -ms-flex-align:start;
    align-items:flex-start;
  }

  .middle-sm{
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center;
  }

  .bottom-sm{
    -webkit-box-align:end;
    -ms-flex-align:end;
    align-items:flex-end;
  }

  .around-sm{
    -ms-flex-pack:distribute;
    justify-content:space-around;
  }

  .between-sm{
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
  }

  .first-sm{
    -webkit-box-ordinal-group:0;
    -ms-flex-order:-1;
    order:-1;
  }

  .last-sm{
    -webkit-box-ordinal-group:2;
    -ms-flex-order:1;
    order:1;
  }
}
@media only screen and (min-width: 64em){
  .container{
    width:65rem;
  }

  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-offset-0,
  .col-md-offset-1,
  .col-md-offset-2,
  .col-md-offset-3,
  .col-md-offset-4,
  .col-md-offset-5,
  .col-md-offset-6,
  .col-md-offset-7,
  .col-md-offset-8,
  .col-md-offset-9,
  .col-md-offset-10,
  .col-md-offset-11,
  .col-md-offset-12{
    -webkit-box-sizing:border-box;
            box-sizing:border-box;
    -webkit-box-flex:0;
    -ms-flex:0 0 auto;
    flex:0 0 auto;
    padding-right:0.5rem;
    padding-left:0.5rem;
  }

  .col-md{
    -webkit-box-flex:1;
    -ms-flex-positive:1;
    flex-grow:1;
    -ms-flex-preferred-size:0;
    flex-basis:0;
    max-width:100%;
  }

  .col-md-1{
    -ms-flex-preferred-size:8.33333333%;
    flex-basis:8.33333333%;
    max-width:8.33333333%;
  }

  .col-md-2{
    -ms-flex-preferred-size:16.66666667%;
    flex-basis:16.66666667%;
    max-width:16.66666667%;
  }

  .col-md-3{
    -ms-flex-preferred-size:25%;
    flex-basis:25%;
    max-width:25%;
  }

  .col-md-4{
    -ms-flex-preferred-size:33.33333333%;
    flex-basis:33.33333333%;
    max-width:33.33333333%;
  }

  .col-md-5{
    -ms-flex-preferred-size:41.66666667%;
    flex-basis:41.66666667%;
    max-width:41.66666667%;
  }

  .col-md-6{
    -ms-flex-preferred-size:50%;
    flex-basis:50%;
    max-width:50%;
  }

  .col-md-7{
    -ms-flex-preferred-size:58.33333333%;
    flex-basis:58.33333333%;
    max-width:58.33333333%;
  }

  .col-md-8{
    -ms-flex-preferred-size:66.66666667%;
    flex-basis:66.66666667%;
    max-width:66.66666667%;
  }

  .col-md-9{
    -ms-flex-preferred-size:75%;
    flex-basis:75%;
    max-width:75%;
  }

  .col-md-10{
    -ms-flex-preferred-size:83.33333333%;
    flex-basis:83.33333333%;
    max-width:83.33333333%;
  }

  .col-md-11{
    -ms-flex-preferred-size:91.66666667%;
    flex-basis:91.66666667%;
    max-width:91.66666667%;
  }

  .col-md-12{
    -ms-flex-preferred-size:100%;
    flex-basis:100%;
    max-width:100%;
  }

  .col-md-offset-0{
    margin-left:0;
  }

  .col-md-offset-1{
    margin-left:8.33333333%;
  }

  .col-md-offset-2{
    margin-left:16.66666667%;
  }

  .col-md-offset-3{
    margin-left:25%;
  }

  .col-md-offset-4{
    margin-left:33.33333333%;
  }

  .col-md-offset-5{
    margin-left:41.66666667%;
  }

  .col-md-offset-6{
    margin-left:50%;
  }

  .col-md-offset-7{
    margin-left:58.33333333%;
  }

  .col-md-offset-8{
    margin-left:66.66666667%;
  }

  .col-md-offset-9{
    margin-left:75%;
  }

  .col-md-offset-10{
    margin-left:83.33333333%;
  }

  .col-md-offset-11{
    margin-left:91.66666667%;
  }

  .start-md{
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    text-align:start;
  }

  .center-md{
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    text-align:center;
  }

  .end-md{
    -webkit-box-pack:end;
    -ms-flex-pack:end;
    justify-content:flex-end;
    text-align:end;
  }

  .top-md{
    -webkit-box-align:start;
    -ms-flex-align:start;
    align-items:flex-start;
  }

  .middle-md{
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center;
  }

  .bottom-md{
    -webkit-box-align:end;
    -ms-flex-align:end;
    align-items:flex-end;
  }

  .around-md{
    -ms-flex-pack:distribute;
    justify-content:space-around;
  }

  .between-md{
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
  }

  .first-md{
    -webkit-box-ordinal-group:0;
    -ms-flex-order:-1;
    order:-1;
  }

  .last-md{
    -webkit-box-ordinal-group:2;
    -ms-flex-order:1;
    order:1;
  }
}
@media only screen and (min-width: 75em){
  .container{
    width:76rem;
  }

  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-offset-0,
  .col-lg-offset-1,
  .col-lg-offset-2,
  .col-lg-offset-3,
  .col-lg-offset-4,
  .col-lg-offset-5,
  .col-lg-offset-6,
  .col-lg-offset-7,
  .col-lg-offset-8,
  .col-lg-offset-9,
  .col-lg-offset-10,
  .col-lg-offset-11,
  .col-lg-offset-12{
    -webkit-box-sizing:border-box;
            box-sizing:border-box;
    -webkit-box-flex:0;
    -ms-flex:0 0 auto;
    flex:0 0 auto;
    padding-right:0.5rem;
    padding-left:0.5rem;
  }

  .col-lg{
    -webkit-box-flex:1;
    -ms-flex-positive:1;
    flex-grow:1;
    -ms-flex-preferred-size:0;
    flex-basis:0;
    max-width:100%;
  }

  .col-lg-1{
    -ms-flex-preferred-size:8.33333333%;
    flex-basis:8.33333333%;
    max-width:8.33333333%;
  }

  .col-lg-2{
    -ms-flex-preferred-size:16.66666667%;
    flex-basis:16.66666667%;
    max-width:16.66666667%;
  }

  .col-lg-3{
    -ms-flex-preferred-size:25%;
    flex-basis:25%;
    max-width:25%;
  }

  .col-lg-4{
    -ms-flex-preferred-size:33.33333333%;
    flex-basis:33.33333333%;
    max-width:33.33333333%;
  }

  .col-lg-5{
    -ms-flex-preferred-size:41.66666667%;
    flex-basis:41.66666667%;
    max-width:41.66666667%;
  }

  .col-lg-6{
    -ms-flex-preferred-size:50%;
    flex-basis:50%;
    max-width:50%;
  }

  .col-lg-7{
    -ms-flex-preferred-size:58.33333333%;
    flex-basis:58.33333333%;
    max-width:58.33333333%;
  }

  .col-lg-8{
    -ms-flex-preferred-size:66.66666667%;
    flex-basis:66.66666667%;
    max-width:66.66666667%;
  }

  .col-lg-9{
    -ms-flex-preferred-size:75%;
    flex-basis:75%;
    max-width:75%;
  }

  .col-lg-10{
    -ms-flex-preferred-size:83.33333333%;
    flex-basis:83.33333333%;
    max-width:83.33333333%;
  }

  .col-lg-11{
    -ms-flex-preferred-size:91.66666667%;
    flex-basis:91.66666667%;
    max-width:91.66666667%;
  }

  .col-lg-12{
    -ms-flex-preferred-size:100%;
    flex-basis:100%;
    max-width:100%;
  }

  .col-lg-offset-0{
    margin-left:0;
  }

  .col-lg-offset-1{
    margin-left:8.33333333%;
  }

  .col-lg-offset-2{
    margin-left:16.66666667%;
  }

  .col-lg-offset-3{
    margin-left:25%;
  }

  .col-lg-offset-4{
    margin-left:33.33333333%;
  }

  .col-lg-offset-5{
    margin-left:41.66666667%;
  }

  .col-lg-offset-6{
    margin-left:50%;
  }

  .col-lg-offset-7{
    margin-left:58.33333333%;
  }

  .col-lg-offset-8{
    margin-left:66.66666667%;
  }

  .col-lg-offset-9{
    margin-left:75%;
  }

  .col-lg-offset-10{
    margin-left:83.33333333%;
  }

  .col-lg-offset-11{
    margin-left:91.66666667%;
  }

  .start-lg{
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    text-align:start;
  }

  .center-lg{
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    text-align:center;
  }

  .end-lg{
    -webkit-box-pack:end;
    -ms-flex-pack:end;
    justify-content:flex-end;
    text-align:end;
  }

  .top-lg{
    -webkit-box-align:start;
    -ms-flex-align:start;
    align-items:flex-start;
  }

  .middle-lg{
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center;
  }

  .bottom-lg{
    -webkit-box-align:end;
    -ms-flex-align:end;
    align-items:flex-end;
  }

  .around-lg{
    -ms-flex-pack:distribute;
    justify-content:space-around;
  }

  .between-lg{
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
  }

  .first-lg{
    -webkit-box-ordinal-group:0;
    -ms-flex-order:-1;
    order:-1;
  }

  .last-lg{
    -webkit-box-ordinal-group:2;
    -ms-flex-order:1;
    order:1;
  }
}
h1,
h2,
h3,
h4,
h5,
h6{
  font-family:${props => props.theme.headingsFontFamily};

  margin-bottom:${props => props.theme.headingsMarginBottom};

  color:${props => props.theme.palette.content};
  -webkit-font-smoothing:antialiased;
}
strong,
b{
  font-weight:500;
}
em{
  line-height:1.25rem;
}
.title--primary{
    font-size:4rem;
    line-height:4.56rem;

    letter-spacing:0.5px;
  }
.title--secondary{
    font-size:2rem;
    line-height:2.625rem;

    letter-spacing:0.2px;
  }
.title--spaced{
    letter-spacing:10px;
  }
.title--underlined{
    position:relative;

    margin-bottom:2rem;

    padding-bottom:1rem;
  }
.title--underlined::after{
      position:absolute;
      bottom:0;
      left:50%;

      display:inline-block;

      width:4rem;
      height:3px;

      content:"";
      -webkit-transform:translateX(-50%);
              transform:translateX(-50%);

      background:${props => props.theme.palette.accentPrimary1};
    }
.title--underlined.text--color-white::after{
        background:${props => props.theme.palette.backgroundPrimary};
      }
h1,
.title--large{
  font-size:1.625rem;
  font-weight:normal;
  line-height:2rem;
}
h2,
.title--medium{
  font-size:1.375rem;
  font-weight:500;
  line-height:1.75rem;
}
h3,
.title--small{
  font-size:1.125rem;
  font-weight:500;
  line-height:1.5rem;
}
.number{
  font-family:${props => props.theme.numbersFontFamily};
}
.number--large{
    font-size:3.25rem;

    font-weight:300;
    line-height:4rem;
  }
.number--extra-large{
    font-size:5rem;
    line-height:6rem;
  }
.number--weight-bold{
    font-weight:bold;
  }
.number__currency{
    font-size:0.5em;
    line-height:0.5em;

    vertical-align:super;
  }
.text--weight-light{
    font-weight:300;
  }
.text--weight-normal{
    font-weight:normal;
  }
.text--weight-medium,
  .text--weight-bold{
    font-weight:500;
  }
.text--weight-fat{
    font-weight:800;
  }
.text--legal{
    font-size:0.75rem;
    line-height:1rem;

    color:${props => props.theme.palette.content};
  }
.text--link,
  .text--dotted{
    padding-bottom:1px;

    text-decoration:none;

    color:${props => props.theme.palette.content};
    border-bottom:1px solid ${props => props.theme.palette.accentSecondary1};
  }
.text--link:active,
    .text--link:hover,
    .text--link:focus,
    .text--dotted:active,
    .text--dotted:hover,
    .text--dotted:focus{
      text-decoration:none;

      color:${props => props.theme.palette.content};
    }
.text--dotted{
    padding-bottom:2px;

    border-bottom:none;
    background-image:-webkit-gradient(linear, left top, right top, color-stop(40%, rgb(107 191 255)), color-stop(20%, rgb(107 191 255 / 0%)));
    background-image:linear-gradient(to right, rgb(107 191 255) 40%, rgb(107 191 255 / 0%) 20%);
    background-repeat:repeat-x;
    background-position:bottom;
    background-size:5px 2px;
  }
.text--underlined{
    text-decoration:underline;
  }
.text--align-left{
      text-align:left;
    }
.text--align-center{
      text-align:center;
    }
.text--align-right{
      text-align:right;
    }
.text--align-justified{
      text-align:justify;
    }
.text--color-default{
      color:${props => props.theme.palette.content};
    }
.text--color-primary{
      color:${props => props.theme.palette.actionablePrimary};
    }
.text--color-green{
      color:${props => props.theme.palette.actionablePrimary};
    }
.text--color-white{
      color:${props => props.theme.palette.contentReverse};
    }
.text--color-blue{
      color:${props => props.theme.palette.semanticInfoStrong};
    }
.text--color-orange{
      color:${props => props.theme.palette.semanticWarning};
    }
.text--color-black{
      color:${props => props.theme.palette.content};
    }
.text--color-red{
      color:${props => props.theme.palette.semanticError};
    }
.text--color-mandarin{
      color:${props => props.theme.palette.semanticError};
    }
.text--color-slate{
      color:${props => props.theme.palette.content};
    }
.text--color-slate-light{
      color:${props => props.theme.palette.contentWeak};
    }
.text--color-gray{
      color:${props => props.theme.palette.semanticInfo};
    }
.text--color-gray-dark{
      color:${props => props.theme.palette.contentWeak};
    }
.text--size-xsmall{
      font-size:0.75rem;
    }
.text--size-small{
      font-size:0.875rem;
    }
.text--size-large{
      font-size:2rem;
    }
.text--line-height-none{
    line-height:0;
  }
.text--line-height-small{
    line-height:1.125rem;
  }
.text--transform-uppercase{
      text-transform:uppercase;
    }
.text--transform-lowercase{
      text-transform:lowercase;
    }
.text--transform-capitalize{
      text-transform:capitalize;
    }
.text--transform-none{
      text-transform:none;
    }
.layout-default{
    width:100%;
    max-width:${props => props.theme.layoutMaxWidth};
  }
.layout__wrap{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
        -ms-flex-direction:column;
            flex-direction:column;

    min-height:100vh;
  }
.layout__main{
    -webkit-box-flex:1;
        -ms-flex:1 0 auto;
            flex:1 0 auto;
  }
.section{
  margin-bottom:2rem;
}
.section--xs{
    margin-bottom:0.5rem;
  }
.section--sm{
    margin-bottom:1rem;
  }
.section--lg{
    margin-bottom:3rem;
  }
.section--xl{
    margin-bottom:5rem;
  }
.container-fluid{
    padding:0 1.5rem;
  }
@media only screen and (min-width: 48em){
.container-fluid{
      padding:0 2rem
  }
    }
.container-padding--xs{
      padding:0.5rem 0.375rem;
    }
@media only screen and (min-width: 48em){
.container-padding--xs{
        padding:0.5rem
    }
      }
.container-padding--sm{
      padding:1rem 0.75rem;
    }
@media only screen and (min-width: 48em){
.container-padding--sm{
        padding:1rem
    }
      }
.container-padding,
    .container-padding--md{
      padding:2rem 1.5rem;
    }
@media only screen and (min-width: 48em){
.container-padding,
    .container-padding--md{
        padding:2rem
    }
      }
.container-padding--lg{
      padding:4rem 3rem;
    }
@media only screen and (min-width: 48em){
.container-padding--lg{
        padding:4rem
    }
      }
.container--color-primary{
      background-color:${props => props.theme.palette.actionablePrimary};
    }
.container--color-primary-light{
      background-color:${props => props.theme.palette.backgroundAccentCard};
    }
.container--color-lighter{
      background-color:${props => props.theme.palette.backgroundPage};
    }
.container--color-lightest{
      background-color:${props => props.theme.palette.backgroundPage};
    }
.container--color-dark{
      background-color:${props => props.theme.palette.contentWeak};
    }
.container--color-white{
      background-color:${props => props.theme.palette.contentReverse};
    }
.container--color-mandarin{
      background-color:${props => props.theme.palette.semanticError};
    }
.container--border-round{
      border-radius:${props => props.theme.containerBorderRadius};
    }
.container--border-primary{
      border:3px solid ${props => props.theme.palette.actionablePrimary};
    }
.container--border-light{
      border:3px solid ${props => props.theme.palette.border};
    }
.container--border-black{
      border:3px solid ${props => props.theme.palette.border};
    }
.container__header--ruled{
    position:relative;

    overflow:hidden;

    margin-bottom:-0.5em;

    text-align:center;
  }
.container__header--ruled::before,
    .container__header--ruled::after{
      position:absolute;
      top:50%;

      overflow:hidden;

      width:50%;

      height:1px;

      content:"";
      -webkit-transform:translateY(-50%);
              transform:translateY(-50%);

      background-color:${props => props.theme.palette.border};
    }
.container__header--ruled::before{
      margin-left:calc(-50% - 1em);
    }
.container__header--ruled::after{
      margin-left:1em;
    }
.container__header--ruled + .container--ruled{
      border-top:none;
    }
.container--ruled{
    border-top:1px solid ${props => props.theme.palette.border};
    border-bottom:1px solid ${props => props.theme.palette.border};
  }
.container--placeholder{
    border:1px dashed ${props => props.theme.palette.border};
  }
.row-divided{
  -ms-flex-wrap:nowrap;
      flex-wrap:nowrap;
}
.row-divided > [class*="col-xs"]:not(:first-child),
  .row-divided > [class^="col-xs"]:not(:first-child){
    border-left:1px solid ${props => props.theme.palette.border};
  }
.row-divided--primary > [class*="col-xs"]:not(:first-child),
    .row-divided--primary > [class^="col-xs"]:not(:first-child){
      border-left:1px solid ${props => props.theme.palette.border};
    }
.col-xs-content{
  -webkit-box-flex:0;
      -ms-flex:0 0 auto;
          flex:0 0 auto;

  max-width:100%;
  padding-right:0.5rem;
  padding-left:0.5rem;
}
@media only screen and (min-width: 48em){
.col-sm-content{
    -webkit-box-flex:0;
        -ms-flex:0 0 auto;
            flex:0 0 auto;

    max-width:100%;
    padding-right:0.5rem;
    padding-left:0.5rem
}
  }
@media only screen and (min-width: 64em){
.col-md-content{
    -webkit-box-flex:0;
        -ms-flex:0 0 auto;
            flex:0 0 auto;

    max-width:100%;
    padding-right:0.5rem;
    padding-left:0.5rem
}
  }
@media only screen and (min-width: 75em){
.col-lg-content{
    -webkit-box-flex:0;
        -ms-flex:0 0 auto;
            flex:0 0 auto;

    max-width:100%;
    padding-right:0.5rem;
    padding-left:0.5rem
}
  }
.form .row,
.row-sm{
  margin-right:-0.25rem;
  margin-left:-0.25rem;
}
.form .row > [class*="col-"],
  .form .row > [class^="col-"],
  .row-sm > [class*="col-"],
  .row-sm > [class^="col-"]{
    padding-right:0.25rem;
    padding-left:0.25rem;
  }
.row-lg{
  margin-right:-1rem;
  margin-left:-1rem;
}
.row-lg > [class*="col-"],
  .row-lg > [class^="col-"]{
    padding-right:1rem;
    padding-left:1rem;
  }
.row-xl{
  margin-right:-2rem;
  margin-left:-2rem;
}
.row-xl > [class*="col-"],
  .row-xl > [class^="col-"]{
    padding-right:2rem;
    padding-left:2rem;
  }
.start-xs{
  text-align:left;
}
.end-xs{
  text-align:right;
}
@media only screen and (min-width: 48em){
.start-sm{
    text-align:left
}
  }
@media only screen and (min-width: 48em){
.end-sm{
    text-align:right
}
  }
@media only screen and (min-width: 64em){
.start-md{
    text-align:left
}
  }
@media only screen and (min-width: 64em){
.end-md{
    text-align:right
}
  }
@media only screen and (min-width: 75em){
.start-lg{
    text-align:left
}
  }
@media only screen and (min-width: 75em){
.end-lg{
    text-align:right
}
  }
.invisible{
  visibility:hidden !important;
}
.hidden{
  display:none !important;
}
@media only screen and (min-width: 30em){
.hidden-xs{
      display:none !important
  }
    }
@media only screen and (min-width: 48em){
.hidden-sm{
      display:none !important
  }
    }
@media only screen and (min-width: 64em){
.hidden-md{
      display:none !important
  }
    }
@media only screen and (min-width: 75em){
.hidden-lg{
      display:none !important
  }
    }
.visible{
  display:block !important;
}
@media only screen and (min-width: 30em){
.visible-xs{
      display:block !important
  }

      th.visible-xs,
      td.visible-xs{
        display:table-cell !important;
      }
    }
@media only screen and (min-width: 48em){
.visible-sm{
      display:block !important
  }

      th.visible-sm,
      td.visible-sm{
        display:table-cell !important;
      }
    }
@media only screen and (min-width: 64em){
.visible-md{
      display:block !important
  }

      th.visible-md,
      td.visible-md{
        display:table-cell !important;
      }
    }
@media only screen and (min-width: 75em){
.visible-lg{
      display:block !important
  }

      th.visible-lg,
      td.visible-lg{
        display:table-cell !important;
      }
    }
.footer{
  font-weight:300;

  margin-top:4rem;

  padding:2.5rem 1.5rem;

  color:${props => props.theme.palette.content};

  background:${props => props.theme.palette.backgroundPrimary};
}
.footer__logo{
    margin-bottom:1.25rem;
  }
.footer-menu{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
        -ms-flex-direction:column;
            flex-direction:column;

    margin-bottom:2rem;
  }
.footer-menu > li{
      margin-bottom:1rem;
    }
@media only screen and (min-width: 48em){
.footer-menu > li{
        margin-right:3rem
    }
      }
.footer-menu__category{
      font-size:0.75rem;
      font-weight:500;

      display:block;

      margin-bottom:1rem;

      letter-spacing:3px;
      text-transform:uppercase;

      color:${props => props.theme.palette.content};
    }
.footer-menu__item{
      font-size:1.125rem;
      font-weight:${props => props.theme.fontWeightBase};

      margin-bottom:0.75rem;
    }
.footer-menu__item__link{
        position:relative;

        display:inline-block;

        text-decoration:none;

        color:${props => props.theme.palette.content};
      }
.footer-menu__item__link::after{
          position:absolute;
          bottom:-3px;

          display:block;

          width:0;
          height:2px;

          content:"";
          -webkit-transition:width 0.2s;
          transition:width 0.2s;

          background-color:${props => props.theme.palette.content};
        }
@media (hover: none){
.footer-menu__item__link::after{
            display:none
        }
          }
.footer-menu__item__link:hover{
          text-decoration:none;

          color:${props => props.theme.palette.content};
        }
.footer-menu__item__link:hover::after{
            width:100%;
          }
@media only screen and (min-width: 48em){
.footer-menu__item{
        margin-right:1rem;
        margin-bottom:1.75rem
    }
      }
@media only screen and (min-width: 48em){
.footer-menu{
      margin-bottom:4rem;
      -webkit-box-orient:horizontal;
      -webkit-box-direction:normal;
          -ms-flex-flow:wrap row;
              flex-flow:wrap row;
      -webkit-box-pack:start;
          -ms-flex-pack:start;
              justify-content:flex-start
  }
    }
.footer-contact{
    text-decoration:underline;
    unicode-bidi:bidi-override;
    direction:rtl;
  }
.footer-badges{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
        -ms-flex-direction:column;
            flex-direction:column;

    -webkit-box-align:center;

        -ms-flex-align:center;

            align-items:center;
  }
.footer-badges img{
      border-radius:8px;
    }
.footer-badges__item{
      margin-bottom:0.25rem;
    }
@media only screen and (min-width: 30em){
.footer-badges__item{
        margin-right:0.25rem
    }
      }
@media only screen and (min-width: 48em){
.footer-badges{
      -webkit-box-orient:horizontal;
      -webkit-box-direction:normal;
          -ms-flex-direction:row;
              flex-direction:row;

      -webkit-box-align:start;

          -ms-flex-align:start;

              align-items:start
  }
    }
.footer-info{
    line-height:1.125rem;
  }
.footer-info__disclaimer{
      text-align:left;
    }
.footer-social{
    margin-bottom:2.5rem;
  }
.footer-social__item,
    .footer-social__item:hover{
      font-size:2.5rem;

      text-decoration:none;

      color:${props => props.theme.palette.actionablePrimary};
    }
.footer-social__item:not(:first-child){
      margin-left:0.5rem;
    }
@media only screen and (min-width: 48em){
.footer-social{
      margin-bottom:2rem
  }
    }
@media only screen and (min-width: 48em){
.footer{
    padding:4.75rem 0
}
  }
.list--unstyled{
  padding-left:0;

  list-style-type:none;
}
.list-links > li{
    margin-bottom:0.5rem;
  }
.list-links > li > a{
      text-decoration:none;
    }
.header{
  font-weight:500;

  display:-webkit-box;

  display:-ms-flexbox;

  display:flex;
  -ms-flex-wrap:wrap;
      flex-wrap:wrap;

  margin-bottom:2rem;
  padding-top:2rem;

  -webkit-box-pack:justify;

      -ms-flex-pack:justify;

          justify-content:space-between;
  -webkit-box-align:center;
      -ms-flex-align:center;
          align-items:center;
}
.header.header--mobile{
    margin-bottom:1rem;
    padding-top:3rem;
  }
.header-nav{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -ms-flex-wrap:wrap;
        flex-wrap:wrap;
    -webkit-box-align:center;
        -ms-flex-align:center;
            align-items:center;
  }
.header-nav__aside,
    .header--collapsed .header-nav__aside{
      margin:0 1rem;
    }
@media only screen and (min-width: 59em){
        .header-nav__aside.header-last-sm, .header--collapsed .header-nav__aside.header-last-sm{
          margin-right:0;
          -webkit-box-ordinal-group:2;
              -ms-flex-order:1;
                  order:1;
        }
      }
.header-nav__input{
      display:none;
    }
.header-nav__toggle,
    .header--collapsed .header-nav__toggle{
      line-height:0.875rem;

      position:relative;

      display:inline-block;
      overflow:hidden;

      width:2rem;

      margin:0;
      padding-left:2rem;

      cursor:pointer;
      -webkit-transition:opacity 0.2s linear;
      transition:opacity 0.2s linear;

      color:${props => props.theme.palette.actionablePrimary};
    }
.header-nav__toggle::before,
      .header-nav__toggle::after,
      .header--collapsed .header-nav__toggle::before,
      .header--collapsed .header-nav__toggle::after{
        position:absolute;
        left:0;

        display:block;

        width:2rem;
        height:6px;

        content:"";

        border-top:2px solid ${props => props.theme.palette.accentPrimary1};
        border-bottom:2px solid ${props => props.theme.palette.accentPrimary1};

        background-color:transparent;
      }
.header-nav__toggle::before, .header--collapsed .header-nav__toggle::before{
        top:0;
      }
.header-nav__toggle::after, .header--collapsed .header-nav__toggle::after{
        top:8px;
      }
@media only screen and (min-width: 30em){
.header-nav__toggle,
    .header--collapsed .header-nav__toggle{
        padding-left:3rem
    }
      }
@media only screen and (min-width: 59em){
.header-nav__toggle{
        display:none
    }
      }
.header-nav-links{
      margin-bottom:0;
    }
.header-nav-links__item{
        margin-bottom:0;
      }
.header-nav-menu,
    .header--collapsed .header-nav-menu{
      font-size:inherit;
      line-height:inherit;

      position:fixed;
      z-index:${props => props.theme.zIndex.header};
      top:0;
      right:0;
      bottom:0;

      overflow-y:auto;

      width:20em;
      padding:2.5rem 2rem;

      -webkit-transition:-webkit-transform 0.2s ease-in-out, -webkit-box-shadow 0.2s 0.1s ease-in;

      transition:-webkit-transform 0.2s ease-in-out, -webkit-box-shadow 0.2s 0.1s ease-in;

      transition:transform 0.2s ease-in-out, box-shadow 0.2s 0.1s ease-in;

      transition:transform 0.2s ease-in-out, box-shadow 0.2s 0.1s ease-in, -webkit-transform 0.2s ease-in-out, -webkit-box-shadow 0.2s 0.1s ease-in;
      -webkit-transform:translateX(20em);
              transform:translateX(20em);

      background:${props => props.theme.palette.backgroundPrimary};
      -webkit-box-shadow:0 0 0 100vw rgb(120 120 120 / 0%);
              box-shadow:0 0 0 100vw rgb(120 120 120 / 0%);
    }
.header-nav-menu.mobile-menu, .header--collapsed .header-nav-menu.mobile-menu{
        right:unset;
        left:0;

        -webkit-transform:translateX(-20em);

                transform:translateX(-20em);
      }
.header-nav-menu .header-nav__toggle, .header--collapsed .header-nav-menu .header-nav__toggle{
        overflow:initial;

        width:auto;

        padding-left:3rem;
      }
.header-nav-menu__items, .header--collapsed .header-nav-menu__items{
        margin-bottom:0;
        padding:1.5rem 0 1.5rem 3rem;
      }
.header-nav-menu__item, .header--collapsed .header-nav-menu__item{
        position:relative;

        display:block;

        margin-bottom:1rem;
      }
.header-nav-menu__item:not(:first-of-type), .header--collapsed .header-nav-menu__item:not(:first-of-type){
          margin-left:0;
        }
.header-nav-menu__link,
      .header-nav-menu__btn,
      .header-nav-menu__link:hover,
      .header-nav-menu__btn:hover,
      .header--collapsed .header-nav-menu__link,
      .header--collapsed .header-nav-menu__btn,
      .header--collapsed .header-nav-menu__link:hover,
      .header--collapsed .header-nav-menu__btn:hover{
        font-size:1rem;
        line-height:1rem;

        position:relative;

        -webkit-transition:color 0.2s ease-in;

        transition:color 0.2s ease-in;

        text-decoration:none;
        letter-spacing:1px;

        color:${props => props.theme.palette.content};
      }
.header-nav-menu__link, .header--collapsed .header-nav-menu__link{
        margin-right:0;
        padding-right:0;

        border:none;
      }
.header-nav-menu__link.active, .header--collapsed .header-nav-menu__link.active{
          color:${props => props.theme.palette.actionablePrimary};
        }
.header-nav-menu__link:hover,
      .header-nav-menu__btn:hover,
      .header--collapsed .header-nav-menu__link:hover,
      .header--collapsed .header-nav-menu__btn:hover{
        color:${props => props.theme.palette.actionablePrimary};
      }
.header-nav-menu__btn, .header--collapsed .header-nav-menu__btn{
        font-size:1rem;

        padding:0.7rem 0.5rem;
      }
.header-nav-menu__btn:hover, .header--collapsed .header-nav-menu__btn:hover{
          background-color:transparent;
        }
.header-nav-menu__separator, .header--collapsed .header-nav-menu__separator{
        margin-bottom:2.25rem;
        padding-top:1.25rem;

        border-bottom:1px solid ${props => props.theme.palette.border};
      }
.header-nav-menu .header-nav__toggle::before,
        .header-nav-menu .header-nav__toggle::after{
          left:0;
          -webkit-transition:height 0.2s 0.2s ease-in-out, top 0.2s 0.2s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0s ease-in-out;
          transition:height 0.2s 0.2s ease-in-out, top 0.2s 0.2s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0s ease-in-out;
          transition:height 0.2s 0.2s ease-in-out, top 0.2s 0.2s ease-in-out, transform 0.2s 0s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out;
          transition:height 0.2s 0.2s ease-in-out, top 0.2s 0.2s ease-in-out, transform 0.2s 0s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0s ease-in-out;

          -webkit-transform:rotateX(0);

                  transform:rotateX(0);
        }
@media only screen and (min-width: 59em){
.header-nav-menu{
        position:static;

        overflow:hidden;

        width:auto;
        padding:0;

        -webkit-transform:translateX(0);

                transform:translateX(0);

        background:none;
        -webkit-box-shadow:none;
                box-shadow:none
    }

        .header-nav-menu__items{
          padding:0;
        }

        .header-nav-menu__item{
          display:inline-block;

          margin-bottom:0;
        }

        .header-nav-menu__link{
          display:inline-block;

          margin-right:0.75rem;
          padding-right:0.75rem;

          border-right:1px solid ${props => props.theme.palette.border};
        }

          .header-nav-menu__item:last-of-type .header-nav-menu__link{
            margin-right:0;
            padding-right:0;

            border:none;
          }

        .header-nav-menu__btn{
          -webkit-transition:background-color 0.2s linear;
          transition:background-color 0.2s linear;

          border:2px solid ${props => props.theme.palette.border};
          border-radius:4px;

          background-color:transparent;
        }

          .header-nav-menu__btn:hover{
            -webkit-transition:background-color 0.2s linear;
            transition:background-color 0.2s linear;

            color:${props => props.theme.palette.content};
            background-color:transparent;
          }

        .header-nav-menu__separator{
          display:none;
        }
      }
@media only screen and (min-width: 59em){
.header--collapsed .header-nav__toggle{
    width:auto
}
  }
@media only screen and (min-width: 75em){
.header-nav__input:checked ~ .header-nav__toggle{
    pointer-events:none;

    opacity:0
}
  }
.header-nav__input:checked ~ .header-nav-menu{
  -webkit-transform:translateX(0);
          transform:translateX(0);

  -webkit-box-shadow:-50vw 0 0 300vw rgb(219 216 214 / 50%), -3px 0 50px rgb(0 0 0 / 50%);

          box-shadow:-50vw 0 0 300vw rgb(219 216 214 / 50%), -3px 0 50px rgb(0 0 0 / 50%);
}
.header-nav__input:checked ~ .header-nav-menu .header-nav__toggle:hover::before{
      -webkit-transform:rotateZ(45deg);
              transform:rotateZ(45deg);
    }
.header-nav__input:checked ~ .header-nav-menu .header-nav__toggle:hover::after{
      -webkit-transform:rotateZ(-45deg);
              transform:rotateZ(-45deg);
    }
.header-nav__input:checked ~ .header-nav-menu .header-nav__toggle:hover::before,
    .header-nav__input:checked ~ .header-nav-menu .header-nav__toggle:hover::after{
      top:5px;
      left:0.25rem;

      width:1.5rem;

      height:0;
      -webkit-transition:height 0.1s 0s ease-in-out, top 0.1s 0s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0.1s ease-in-out;
      transition:height 0.1s 0s ease-in-out, top 0.1s 0s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0.1s ease-in-out;
      transition:height 0.1s 0s ease-in-out, top 0.1s 0s ease-in-out, transform 0.2s 0.1s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out;
      transition:height 0.1s 0s ease-in-out, top 0.1s 0s ease-in-out, transform 0.2s 0.1s ease-in-out, width 0.2s 0s ease-in-out, left 0.2s 0s ease-in-out, border-width 0.2s 0s ease-in-out, -webkit-transform 0.2s 0.1s ease-in-out;

      border-width:1px;
    }
@media only screen and (min-width: 59em){
.header-nav__input:checked ~ .header-nav-menu{
    -webkit-box-shadow:-50vw 0 0 300vw rgb(155 155 155 / 0%), -3px 0 50px rgb(0 0 0 / 5%);
            box-shadow:-50vw 0 0 300vw rgb(155 155 155 / 0%), -3px 0 50px rgb(0 0 0 / 5%)
}
  }
.header--white .header-nav > .header-nav__toggle,
  .header--white.header--collapsed .header-nav > .header-nav__toggle{
    color:${props => props.theme.palette.contentReverse};
  }
.header--white .header-nav > .header-nav__toggle::before,
    .header--white .header-nav > .header-nav__toggle::after,
    .header--white.header--collapsed .header-nav > .header-nav__toggle::before,
    .header--white.header--collapsed .header-nav > .header-nav__toggle::after{
      border-color:${props => props.theme.palette.contentReverse};
    }
.header--white .header-nav__aside .header-nav-menu__link,
    .header--white .header-nav__aside .header-nav-menu__btn,
    .header--white .header--collapsed .header-nav__aside .header-nav-menu__link,
    .header--white .header--collapsed .header-nav__aside .header-nav-menu__btn{
      color:${props => props.theme.palette.contentReverse};
    }
.header--white .header-nav__aside .header-nav-menu__link:hover, .header--white .header--collapsed .header-nav__aside .header-nav-menu__link:hover{
      color:${props => props.theme.palette.actionablePrimary};
    }
.header--white .header-nav-menu__btn{
      color:${props => props.theme.palette.contentReverse};
      border-color:rgb(255 255 255 / 80%);
    }
.header--white .header-nav-menu__link.active{
        color:${props => props.theme.palette.actionablePrimary};
      }
@media only screen and (min-width: 59em){
      .header--white .header-nav-menu__link{
        border-color:${props => props.theme.palette.contentReverse};
      }

      .header--white .header-nav-menu__link,
      .header--white .header-nav-menu__btn{
        color:${props => props.theme.palette.contentReverse};
      }

      .header--white .header-nav-menu__btn:hover{
        color:${props => props.theme.slatePaletteContent};
      }
    }
@media only screen and (max-width: 767px){
      .header--white.header--white--sm .header-nav > .header-nav__toggle,
      .header--white.header--white--sm.header--collapsed .header-nav > .header-nav__toggle{
        color:${props => props.theme.palette.actionablePrimary};
      }

        .header--white.header--white--sm .header-nav > .header-nav__toggle::before,
        .header--white.header--white--sm .header-nav > .header-nav__toggle::after,
        .header--white.header--white--sm.header--collapsed .header-nav > .header-nav__toggle::before,
        .header--white.header--white--sm.header--collapsed .header-nav > .header-nav__toggle::after{
          border-color:${props => props.theme.palette.actionablePrimary};
        }
        .header--white.header--white--sm .header-nav__aside .header-nav-menu__link,
        .header--white.header--white--sm .header-nav__aside .header-nav-menu__link:hover,
        .header--white.header--white--sm .header-nav__aside .header-nav-menu__btn,
        .header--white.header--white--sm .header--collapsed .header-nav__aside .header-nav-menu__link,
        .header--white.header--white--sm .header--collapsed .header-nav__aside .header-nav-menu__link:hover,
        .header--white.header--white--sm .header--collapsed .header-nav__aside .header-nav-menu__btn{
          color:inherit;
        }
        .header--white.header--white--sm .header-nav-menu__btn{
          color:inherit;
        }
    }
.table{
  width:100%;
  max-width:100%;

  table-layout:fixed;
}
.table thead th{
    font-weight:500;
  }
.table--row-bordered th,
    .table--row-bordered > tbody > tr > td{
      border-bottom:${props => props.theme.tableBorderBottom};
    }
.table--striped tbody > tr:nth-of-type(odd){
      background-color:${props => props.theme.palette.backgroundSecondary};
    }
.sr-only,
.sr-focusable:not(:focus):not(:focus-within){
  position:absolute !important;

  overflow:hidden !important;
  clip:rect(0, 0, 0, 0) !important;

  width:1px !important;
  height:1px !important;
  margin:-1px !important;
  padding:0 !important;

  white-space:nowrap !important;

  border-width:0 !important;
}
.img-equal-housing{
  display:inline-block;

  width:104px;
  height:39px;

  background:url("https://www.upgrade.com/assets/images/equal-housing.svg");
  background-repeat:no-repeat;
}
.img-bbb{
  display:inline-block;

  width:104px;
  height:39px;

  background:url("https://www.upgrade.com/assets/images/bbb.svg");
  background-repeat:no-repeat;
}

`;
